"use strict";

import fetch from '@/utils/fetch';

/**
 * zym.从图书年检，新复制的方法 - 下载文件url
 * @param query
 */
export function filesDownload(query) {
    return fetch({
        // url: '/Material/Material/downMaterialFile',
        url: '/eavar/pfile/url',
        method: 'post',
        data: query
    });
}

/**
 * zym.从图书年检，新复制的方法 - 下载文件url
 * @param query
 */
 export function filesDownloadUploadBtn(query) {
  return fetch({
      // url: '/Material/Material/downMaterialFile',
      url: '/eavar/mfile/url',
      method: 'post',
      data: query
  });
}

export function uploadBase64(query) {
  return fetch({
      url: '/eavar/file/uploadBase64',
      method: 'post',
      data: query
  });
}





// WEBPACK FOOTER //
// ./src/api/file.js